import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=8168247e&scoped=true&"
import script from "./IconBadge.vue?vue&type=script&lang=js&"
export * from "./IconBadge.vue?vue&type=script&lang=js&"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=8168247e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8168247e",
  null
  
)

export default component.exports